class BnPdpUrgencyCounter extends HTMLElement {
  constructor() {
    super();
    this.countEl = this.querySelector('[data-count]');
    this.storageKey = this.dataset.storageKey || `bn-pdp-counter-${window.location.pathname}`;
    this.updateInterval = Number.parseInt(this.dataset.updateInterval, 10) || 300000;
    this.visibleNumber = Number.parseInt(this.dataset.visibleNumber, 10) || Number.parseInt(this.dataset.initialNumber, 10) || 0;
    this.timer = null;
    this.handleVisibility = this.handleVisibility.bind(this);
  }

  connectedCallback() {
    this.tick({ force: true });
    this.timer = window.setInterval(() => this.tick(), 60000);
    document.addEventListener('visibilitychange', this.handleVisibility);
  }

  disconnectedCallback() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  handleVisibility() {
    if (!document.hidden) {
      this.tick({ force: true });
    }
  }

  randomInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  safeRead() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  safeWrite(payload) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(payload));
    } catch (error) {
      // localStorage may be unavailable; fail silently.
    }
  }

  tick({ force = false } = {}) {
    const now = Date.now();
    const data = this.safeRead();
    const initialNumber = Number.parseInt(this.dataset.initialNumber, 10) || 0;

    const ranges = {
      firstLoadMin: Number.parseInt(this.dataset.firstLoadMin, 10) || 150,
      firstLoadMax: Number.parseInt(this.dataset.firstLoadMax, 10) || 200,
      beforeMin: Number.parseInt(this.dataset.beforeMin, 10) || 300,
      beforeMax: Number.parseInt(this.dataset.beforeMax, 10) || 450,
      afterMin: Number.parseInt(this.dataset.afterMin, 10) || 400,
      afterMax: Number.parseInt(this.dataset.afterMax, 10) || 500,
      repeatMin: Number.parseInt(this.dataset.repeatMin, 10) || 400,
      repeatMax: Number.parseInt(this.dataset.repeatMax, 10) || 500
    };

    let next = data && typeof data.value === 'number' && typeof data.lastUpdate === 'number'
      ? { ...data }
      : { value: initialNumber, lastUpdate: now };

    const diff = now - next.lastUpdate;

    if (!data) {
      next.value += this.randomInRange(ranges.firstLoadMin, ranges.firstLoadMax);
    } else if (force) {
      next.value += this.randomInRange(
        diff < this.updateInterval ? ranges.beforeMin : ranges.afterMin,
        diff < this.updateInterval ? ranges.beforeMax : ranges.afterMax
      );
    } else if (diff >= this.updateInterval && !document.hidden) {
      next.value += this.randomInRange(ranges.repeatMin, ranges.repeatMax);
    }

    next.lastUpdate = now;
    this.visibleNumber = Math.max(this.visibleNumber, next.value);

    if (this.countEl) {
      this.countEl.textContent = this.visibleNumber.toLocaleString('es-CL');
    }

    this.safeWrite(next);
  }
}

if (!customElements.get('bn-pdp-urgency-counter')) {
  customElements.define('bn-pdp-urgency-counter', BnPdpUrgencyCounter);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-pdp-demo-download]');
  if (!trigger) return;

  const pdfUrl = trigger.dataset.pdfUrl;
  if (!pdfUrl) return;

  window.open(pdfUrl, '_blank', 'noopener');
});
